"use strict";
/** 클라이언트 측에서 요청 헤더에 기본적으로 포함시키는 platform 값 */
// export enum EnPlatformTypeFromClient {
//   /** 안드로이드 */
//   ANDROID = 'Android',
//   /** iOS */
//   IOS = 'iOS',
//   /** PC 웹 */
//   PW = 'Web',
//   /** 모바일 웹 */
//   MW = 'MWeb',
// }
Object.defineProperty(exports, "__esModule", { value: true });
exports.Platform = void 0;
exports.Platform = {
    ANDROID: 'Android',
    IOS: 'iOS',
    MWeb: 'MWeb',
    Web: 'Web',
};
